import { render, staticRenderFns } from "./UltimaRotina.vue?vue&type=template&id=6cfec680&scoped=true"
import script from "./UltimaRotina.vue?vue&type=script&lang=js"
export * from "./UltimaRotina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfec680",
  null
  
)

export default component.exports